import {Component, OnInit, ViewChild} from '@angular/core';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {RoutingServerGroupApiService} from '../../../services/api/settings/routing-servers/routing-server-groups/routing-server-group-api.service';
import {RoutingServersSettingsApiService} from '../../../services/api/routing-servers/routing-servers-settings-api.service';
import {AcDialogService} from 'ac-infra';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {LogicalConjunctionService} from '../../../services/common/logical-conjunction/logical-conjunction.service';
import {RoutingServersGroupsSettingsSearchComponent} from './routing-servers-groups-settings-search/routing-servers-groups-settings-search.component';
import Search from '../../../utils/search';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {
  RoutingServerGroupMainDialogComponent
} from './routing-server-group-main-dialog/routing-server-group-main-dialog.component';
import * as _ from 'lodash';
import { firstValueFrom } from 'rxjs';
import {RoutingPolicyPipe} from './policy-between-groups.pipe';

@Component({
  selector: 'routing-servers-groups-settings',
  templateUrl: './routing-servers-groups-settings.component.html',
  styleUrls: ['./routing-servers-groups-settings.component.scss']
})
export class RoutingServersGroupsSettingsComponent implements OnInit {

  selection;
  isUnauthorized: boolean;
  filter;
  formNotValid: any;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true,  width: 50},
    {name: 'policyBetweenGroups', display: 'Policy between groups', selected: true, width: 65, transformer: RoutingPolicyPipe},
    {name: 'policyInsideGroup', display: 'policy Inside Group', selected: true, width: 60, transformer: RoutingPolicyPipe},
    {name: 'routers', display: 'Routers', selected: true, width: 300},
  ];

  serverGroups = [];
  routingServers = [];

  routingPolicyOptionsBetweenGroups = [
    {label: 'Sticky primary', server: 'STICKY_PRIMARY'},
    {label: 'Sticky last available', server: 'STICKY_LAST_AVAILABLE'}
  ];

  routingPolicyOptionsInsideGroup = [
    {label: 'Round-robin', server: 'ROUND_ROBIN'},
    {label: 'Sticky primary', server: 'STICKY_PRIMARY'},
    {label: 'Sticky last available', server: 'STICKY_LAST_AVAILABLE'}
  ];

  searchData: any = {};
  searchTerms = [];
  searchObj: any = {name: '', routerIds: []};
  parameters: any = {};

  @ViewChild(VirtualScrollerComponent, {static: false})
  private virtualScroller: VirtualScrollerComponent;
  routingServersSearchComponent = RoutingServersGroupsSettingsSearchComponent;

  constructor(private userPrivilege: UserPrivilegeService,
              private routingServerGroupApiService: RoutingServerGroupApiService,
              private routingServersSettingsApiService: RoutingServersSettingsApiService,
              private dialogService: AcDialogService, public dialog: MatDialog,
              private snackBarService: SnackBarService, private logicalConjunctionService: LogicalConjunctionService) {

  }

  ngOnInit(): void  {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  addGroup(): void {
    const newServerGroup = {
      policyBetweenGroups: this.routingPolicyOptionsBetweenGroups[0].server,
      policyInsideGroup: this.routingPolicyOptionsInsideGroup[0].server,
      id: null,
      groups: [],
      name: 'New server group'
    };

    this.dialogService.open(RoutingServerGroupMainDialogComponent, {
      dialogData: {
        group: newServerGroup,
        routingPolicyOptionsBetweenGroups: this.routingPolicyOptionsBetweenGroups,
        routingPolicyOptionsInsideGroup: this.routingPolicyOptionsInsideGroup,
        routingServers: this.routingServers,
      },
      noSubmitButton: this.isUnauthorized,
      title: 'Add server group',
      onSubmit: () => {
          return firstValueFrom(this.routingServerGroupApiService.addRoutingServerGroup(newServerGroup))
            .then(() => this.refresh());
        }
      });
  }

  refresh(): void {
    this.getGroups();
    this.getRoutingServers();
  }

  onSelection(selected: any): void {
    this.selection = selected;
  }

  getGroups(): void {
    this.routingServerGroupApiService.getRoutingServerGroups(this.generateFilterParameters()).subscribe(serverGroups => {
      this.generateTitles(serverGroups);
      this.policiesToUiPolicies(serverGroups);
      this.serverGroups = serverGroups;
    });
  }

  getRoutingServers(): void{
    this.routingServersSettingsApiService.getRoutingServers({}).subscribe(routingServers => {
      this.routingServers = routingServers;
      this.setSearchOptions();
    });
  }

  generateTitles = (serverGroups) => {
    serverGroups.forEach((group) => {
      group.routers = [];
      group.groups.forEach((servers, index) => {
        const names =  servers.servers.map((server) => server.name).join(', ');
        servers.innerTitle = names;
        group.routers.push(` (${index + 1}) ${names}`);
      });
    });
  }

  policiesToUiPolicies = (serverGroups) => {
    serverGroups.forEach((group) => {
      group.policyBetweenGroups = this.routingPolicyOptionsBetweenGroups.find((server) => {
        return group.policyBetweenGroups === server.server;
      }).server;

      group.policyInsideGroup = this.routingPolicyOptionsInsideGroup.find((server) => {
        return group.policyInsideGroup === server.server;
      }).server;
    });
  }

  private generateFilterParameters(): any {
    const generatedParameters: any = {};

    if (this.parameters.search) {
      if (typeof this.parameters.search === 'string') {
        generatedParameters.filter = {
          searchString: {
            operator: ':',
            value: this.parameters.search
          }
        };
      } else if (typeof this.parameters.search === 'object') {
        generatedParameters.filter = this.parameters.search;
      }
    }

    return generatedParameters;
  }

  onSearch(search): void {
    this.parameters.search = search.filter;
    this.refresh();
  }

  private setSearchOptions(): void {
    this.searchData.routingServers = Search.generateSearchOptions(this.routingServers, 'name', 'id');
    this.searchTerms = [
      {term: 'name', operator: ':', displayName: 'Name'},
      {term: 'routerIds', operator: '=', displayName: 'Routers', displayValue: Search.getOptionValue(this.searchData.routingServers)}
    ];

  }

  editGroup(): void {
    const routingServerGroup = _.cloneDeep(this.selection);

    this.dialogService.open(RoutingServerGroupMainDialogComponent, {
      dialogData: {
        isEdit: true,
        group: routingServerGroup,
        routingPolicyOptionsBetweenGroups: this.routingPolicyOptionsBetweenGroups,
        routingPolicyOptionsInsideGroup: this.routingPolicyOptionsInsideGroup,
        routingServers: this.routingServers,
      },
      title: 'Edit server group',
      noSubmitButton: this.isUnauthorized,
      onSubmit: () => {
        return firstValueFrom(this.routingServerGroupApiService.editRoutingServerGroup(routingServerGroup.id, routingServerGroup))
          .then(() => this.refresh());
      }
    });
  }

  deleteGroup(): void {
    const confirmationMessage = `Are you sure you want to delete the routing server group: "${this.selection.name}" ?`;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.routingServerGroupApiService.deleteRoutingServerGroup(this.selection.id).subscribe(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.logicalConjunctionService
          .generateAndDescription([this.selection], 'name')} successfully deleted`);
      });
    });
  }
}
